import React from "react";
import clsx from "clsx";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { Button, Stack, Typography } from "@curves/ui-base";
import { NavLink } from "react-router-dom";
import { CLUB_MEMBERS_ROUTER } from "@icoach/router/routerPath";
import { MEMBERS_MEMBER_DETAIL_TABS } from "@icoach/constants/";

const EnhanceCyclePurchasePromptDialog = ({ open, onClose, redirectToPage, sourceData }) => {
	const { memberID, contractID } = sourceData || {};

	const handleClose = () => {
		redirectToPage(contractID);
		onClose();
	};

	const handleNoClick = () => {
		redirectToPage(contractID);
	};

	if (!open) return null;

	return (
		<Dialog className={clsx("simple-content", "dialog")} PaperProps={{ className: clsx("wx-40rem") }} open={open} fullWidth>
			<GradientColorHeader onClose={handleClose}>重要提醒</GradientColorHeader>
			<DialogContent>
				<Typography paragraph>該會員有循環訂單，將隨移入一併處理，請確認是否需要更新循環訂單的收件資訊？</Typography>
			</DialogContent>
			<DialogActions>
				<Stack spacing={2}>
					<Button variant="contained" onClick={handleNoClick} color="error">
						否
					</Button>
					<Button variant="contained" color="success" component={NavLink} to={CLUB_MEMBERS_ROUTER.MEMBER_DETAIL.GET_TABS_PATH(memberID, MEMBERS_MEMBER_DETAIL_TABS.HC)}>
						是，前往
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default EnhanceCyclePurchasePromptDialog;
